import React, { Component } from 'react'

class Loading extends Component {
  render () {
    return (
      <div className='b-loading'>
        <div className='b-loading-inner'>
          <div className='b-loading-animation'>
            <div className='b-loading-balls'>
              <div className='b-loading-balls-ball'></div>
              <div className='b-loading-balls-ball'></div>
              <div className='b-loading-balls-ball'></div>
              <div className='b-loading-balls-ball'></div>
              <div className='b-loading-balls-ball'></div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading.js